import { sectionRenderer } from '@theme/section-renderer';

const HIDDEN_CLASS = 'mw-search-hidden';
const LOADING_CLASS = 'mw-catalog-loading';

/**
 * Load-all + live-search for catalog.
 * 1. Loads ALL product pages first (so search isn't stuck on page 1)
 * 2. Filters grid in real-time as user types (no Enter needed)
 */
function init() {
  const searchInput = document.querySelector('[data-mw-search-input]');
  const resultsList = document.querySelector('results-list');
  const grid = document.querySelector('[ref="grid"]');
  if (!(searchInput instanceof HTMLInputElement) || !resultsList || !grid) return;

  const input = searchInput;
  const gridEl = grid;

  const sectionId = resultsList.getAttribute('section-id') || '';
  if (!sectionId) return;

  const lastPage = parseInt(String(gridEl.getAttribute('data-last-page') || '1'), 10);

  // Disable infinite scroll so we control loading: remove triggers
  const viewMoreNext = resultsList.querySelector('[ref="viewMoreNext"]');
  const viewMorePrevious = resultsList.querySelector('[ref="viewMorePrevious"]');
  if (viewMoreNext) viewMoreNext.remove();
  if (viewMorePrevious) viewMorePrevious.remove();

  // Phase 1: Load all remaining pages
  async function loadAllPages() {
    if (lastPage <= 1) {
      setupLiveSearch();
      return;
    }

    gridEl.classList.add(LOADING_CLASS);
    const gridParent = gridEl.parentElement;
    let loadingEl = gridParent?.querySelector('.mw-catalog-loading-msg');
    if (!loadingEl && gridParent) {
      loadingEl = document.createElement('p');
      loadingEl.className = 'mw-catalog-loading-msg';
      loadingEl.textContent = 'Loading all products…';
      loadingEl.setAttribute('aria-live', 'polite');
      gridParent.insertBefore(loadingEl, gridEl);
    }
    if (loadingEl instanceof HTMLElement) loadingEl.hidden = false;

    for (let page = 2; page <= lastPage; page++) {
      const url = new URL(window.location.href);
      url.searchParams.set('page', page.toString());
      url.hash = '';
      const html = await sectionRenderer.getSectionHTML(sectionId, false, url);
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const pageGrid = doc.querySelector('[ref="grid"]');
      if (!pageGrid) continue;
      const cards = pageGrid.querySelectorAll(':scope > [ref="cards[]"]');
      cards.forEach((card) => gridEl.appendChild(card.cloneNode(true)));
    }

    if (loadingEl instanceof HTMLElement) loadingEl.hidden = true;
    gridEl.classList.remove(LOADING_CLASS);

    setupLiveSearch();
  }

  function setupLiveSearch() {
    const cards = Array.from(gridEl.querySelectorAll('[ref="cards[]"]'));
    if (!cards.length) return;

    function filterBySearch(/** @type {string} */ term) {
      const q = (term || '').trim().toLowerCase();
      cards.forEach((card) => {
        const title = ((card instanceof HTMLElement && card.dataset.productTitle) || '').toLowerCase();
        const match = !q || title.includes(q);
        card.classList.toggle(HIDDEN_CLASS, !match);
      });
    }

    /** @type {ReturnType<typeof setTimeout>} */
    let debounceId;
    input.addEventListener('input', () => {
      clearTimeout(debounceId);
      debounceId = setTimeout(() => filterBySearch(input.value), 120);
    });
    input.addEventListener('keyup', () => {
      clearTimeout(debounceId);
      debounceId = setTimeout(() => filterBySearch(input.value), 120);
    });

    const initial = input.value;
    if (initial) filterBySearch(initial);
  }

  loadAllPages();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
